import { render, staticRenderFns } from "./DirectDispatchReceive.html?vue&type=template&id=476bd310&external"
import script from "./DirectDispatchReceive.js?vue&type=script&lang=js&external"
export * from "./DirectDispatchReceive.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports